import React, { type ReactNode } from "react";
import { Box, Typography } from "@mui/material";
import { adminPageRoot } from "../../styles/adminUiTokens";
import { responsiveHeading } from "../../styles/layoutStyles";

export interface AdminPageShellProps {
  title: string;
  description?: ReactNode;
  meta?: ReactNode;
  toolbar?: ReactNode;
  filterChips?: ReactNode;
  alerts?: ReactNode;
  children: ReactNode;
}

const AdminPageShell: React.FC<AdminPageShellProps> = ({
  title,
  description,
  meta,
  toolbar,
  filterChips,
  alerts,
  children,
}) => (
  <Box sx={adminPageRoot} data-testid="admin-page-shell">
    <Box sx={{ mb: toolbar || filterChips ? 2 : 2.5 }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "baseline",
          justifyContent: "space-between",
          gap: 2,
          flexWrap: "wrap",
        }}
      >
        <Typography variant="h5" sx={responsiveHeading}>
          {title}
        </Typography>
        {meta && (
          <Typography variant="body2" color="text.secondary">
            {meta}
          </Typography>
        )}
      </Box>
      {description && (
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{ display: "block", mt: 0.75, lineHeight: 1.5 }}
        >
          {description}
        </Typography>
      )}
    </Box>

    {toolbar}
    {filterChips && <Box sx={{ mt: 1.5, mb: 2 }}>{filterChips}</Box>}
    {alerts}
    {children}
  </Box>
);

export default AdminPageShell;
